<template>
  <div>
    <button
      type="button"
      :class="btnClass"
      aria-label="Share"
      @click="openModal({ id: 'share-product', params: { link, customLink } })"
    >
      <i
        class="mi-share icon-20"
        :class="iconOnly ? '' : 'mr-0 c-sm:c-mr-1'"
      />
      <span
        v-if="!iconOnly"
        :class="textClass"
      >{{ t('share') }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useModalStore } from '@/stores/ModalStore'

const { openModal } = useModalStore()

defineProps({
  link: {
    type: String,
    required: true,
  },

  customLink: {
    type: String,
    default: '',
  },

  btnClass: {
    type: String,
    default: 'btn  btn-primary c-p-2 c-rounded-pill border-0',
  },

  textClass: {
    type: String,
    default: 'hidden c-md:inline-block',
  },

  iconOnly: {
    type: Boolean,
    default: false,
  },
})
const { t } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "share": "Sdílet"
},
    "sk": {
    "share": "Zdieľať"
},
    "pl": {
    "share": "Udostępnij"
},
    "hu": {
    "share": "Megoszt"
},
    "de": {
    "share": "Teilen"
},
    "at": {
    "share": "Teilen"
},
    "ro": {
    "share": "Împărtășit"
},
    "fr": {
    "share": "Partager"
},
    "it": {
    "share": "Condividi"
}
  }
</i18n>
